import { authStore } from "@/store/auth"

/**
 * Resolve a feature flag from the user payload served by the backend.
 *
 * The `/auth/users/me` response contains the final boolean per flag, computed
 * server-side by the EntitlementResolver, which also mirrors legacy `*_enabled`
 * aliases so v1 keys keep resolving. When the flag is missing (e.g. user not
 * authenticated yet) the caller default applies.
 *
 * Security note: this is a UI hint only. Every action gated by a flag is
 * re-checked on the backend with the JWT-derived organization_id.
 */
export function useTypedFeatureFlag(key: string, defaultValue: boolean): boolean {
  const flags = authStore(state => state.user?.feature_flags)

  if (flags && key in flags) return flags[key]

  return defaultValue
}
